import { useEffect, useState } from "react";
import styles from "./Support.module.scss";
import { axiosInstance } from "../../services";
import { useTranslation } from "react-i18next";
import localesKeys from "../../locales/localesKeys.json";

const PrivacyPolicy = () => {
  const {
    i18n: { language },
    t,
  } = useTranslation();
  const [privacyPolicy, setPrivacyPolicy] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const getPolicies = async () => {
    try {
      const response = await axiosInstance.get("/singleton/privacyPolicy");
      setPrivacyPolicy(response?.data?.data || {});
    } catch (error) {
      console.error("Error fetching policies. Please try again!!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPolicies();
  }, []);

  return (
    <div className={styles.container}>
      {isLoading ? (
        <div>Loading....</div>
      ) : (
        <div className={styles.container__inner}>
          <div className={styles.container__inner__title}>
            <h1>{t(localesKeys.FOOTER_SUPPORTLIST_PRIVACY)}</h1>
          </div>
          <div className="ql-editor">
            <div
              className={styles.container__inner__content}
              dangerouslySetInnerHTML={{ __html: privacyPolicy?.[language] }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};
export default PrivacyPolicy;
